import { Link, styled } from '@mui/material'

import Colors from '#/styles/Colors'

const StyledList = styled('ol')({
  margin: 0,
  paddingBottom: 16,
  paddingLeft: 16,
  pointerEvents: 'auto',
})

export const List = ({ value }: any) => {
  if (!value?.length) return null

  return (
    <StyledList>
      {value.map((item, index) => (
        <li
          key={item.label + index}
          style={{
            color: item.level ? Colors.feedback[item.level]?.color : undefined,
          }}
        >
          {item.link ? <Link href={item.link}>{item.label}</Link> : item.label}
        </li>
      ))}
    </StyledList>
  )
}
